@if (viewContextEntrypoint$ | async; as entrypoint) { @for (pagelet of entrypoint.pageletIDs; track pagelet) {
<ish-content-pagelet [pageletId]="pagelet" />
} }
